import React from 'react';
import { Card, Image } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const ClubInfoWindow = ({ club }) => {
  return (
    <Card>
      <Card.Content>
        <Image floated="left" size="tiny" src={club.img} />
        <Card.Header>{club.name}</Card.Header>
        <Card.Meta>{`${club.state}, ${club.country}`}</Card.Meta>
        <Card.Description>{club.intro}</Card.Description>
      </Card.Content>
    </Card>
  );
};

ClubInfoWindow.propTypes = {
  club: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired
  }).isRequired
};

export default ClubInfoWindow;



// WEBPACK FOOTER //
// ./src/components/Maps/ClubInfoWindow.js